import * as React from 'react';
import type { SVGProps } from 'react';
export const SvgCheckCircle1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path
      d="M12 0a12 12 0 1 0 12 12A12.014 12.014 0 0 0 12 0m6.927 8.2-6.845 9.289a1.01 1.01 0 0 1-1.43.188l-4.888-3.908a1 1 0 1 1 1.25-1.562l4.076 3.261 6.227-8.451a1 1 0 1 1 1.61 1.183"
      fill="currentColor"
    />
  </svg>
);
